[
  {
    "id": "r23-power-ge50",
    "rule": 23,
    "cite": [
      "a",
      "a(i)",
      "a(ii)",
      "a(iii)",
      "a(iv)"
    ],
    "scope": "both",
    "cfr": "83.23",
    "cfrCite": [
      "a",
      "a(i)",
      "a(ii)",
      "a(iii)",
      "a(iv)"
    ],
    "title": {
      "en": "Power-driven vessel underway, 50 m or more",
      "de": "Maschinenfahrzeug in Fahrt, 50 m und länger"
    },
    "vessel": "cargo",
    "lengthClass": "ge50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-aft",
        "tier": 1
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "Two masthead lights in a fore-and-aft line, the after one higher, tell you the length: from 50 m the second masthead light is compulsory. The distance between the two lights on the screen shows the aspect: the wider they stand apart, the more you see the vessel from the side.",
      "de": "Zwei Topplichter hintereinander, das achtere höher, sagen dir die Länge: ab 50 m ist das zweite Topplicht Pflicht. Der Abstand der beiden Lichter zeigt den Aspekt: je weiter sie auseinanderstehen, desto mehr siehst du das Fahrzeug von der Seite."
    },
    "tags": [
      "power-driven",
      "underway",
      "masthead"
    ]
  },
  {
    "id": "r23-power-m20to50",
    "rule": 23,
    "cite": [
      "a",
      "a(i)",
      "a(iii)",
      "a(iv)"
    ],
    "scope": "both",
    "cfr": "83.23",
    "cfrCite": [
      "a",
      "a(i)",
      "a(iii)",
      "a(iv)"
    ],
    "title": {
      "en": "Power-driven vessel underway, 20 to 50 m",
      "de": "Maschinenfahrzeug in Fahrt, 20 bis 50 m"
    },
    "vessel": "motor-vessel-30",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "Under 50 m one masthead light is enough; the second one is allowed but not required. So a single masthead light tells you the vessel is under 50 m, while two tell you nothing about the length unless you already know she is over 50 m. A vessel of 12 to 20 m carries the same lights, only with a shorter range: 3 miles for the masthead light instead of 5 (rule 22).",
      "de": "Unter 50 m reicht ein Topplicht, das zweite ist erlaubt, aber nicht Pflicht. Ein einzelnes Topplicht heißt also: unter 50 m. Zwei Topplichter sagen dagegen nichts Sicheres über die Länge. Ein Fahrzeug von 12 bis 20 m führt dieselben Lichter, nur mit kürzerer Tragweite: 3 statt 5 Seemeilen für das Topplicht (Regel 22)."
    },
    "tags": [
      "power-driven",
      "underway",
      "masthead"
    ]
  },
  {
    "id": "r23-power-lt12",
    "rule": 23,
    "cite": [
      "d(i)"
    ],
    "scope": "both",
    "cfr": "83.23",
    "cfrCite": [
      "d"
    ],
    "title": {
      "en": "Power-driven vessel under 12 m",
      "de": "Maschinenfahrzeug unter 12 m"
    },
    "vessel": "motorboat",
    "lengthClass": "m7to12",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "One all-round white light instead of masthead light and sternlight, plus sidelights. From astern you see a white light and nothing else, exactly like a vessel at anchor: only the movement of the light tells them apart.",
      "de": "Ein weißes Rundumlicht statt Topp- und Hecklicht, dazu die Seitenlichter. Von achtern siehst du ein weißes Licht und sonst nichts, genau wie bei einem Ankerlieger: nur die Bewegung des Lichts unterscheidet beide."
    },
    "tags": [
      "power-driven",
      "underway",
      "small"
    ]
  },
  {
    "id": "r23-power-lt7",
    "rule": 23,
    "cite": [
      "d(ii)"
    ],
    "scope": "international",
    "title": {
      "en": "Power-driven vessel under 7 m, max 7 knots",
      "de": "Maschinenfahrzeug unter 7 m, höchstens 7 kn"
    },
    "vessel": "dinghy",
    "lengthClass": "lt7",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "Only an all-round white light is compulsory, sidelights if practicable. This relief exists in the international rules only; the US inland rules do not have it.",
      "de": "Pflicht ist nur das weiße Rundumlicht, Seitenlichter wenn möglich. Diese Erleichterung steht nur in den internationalen Regeln, die US-Binnenregeln kennen sie nicht."
    },
    "tags": [
      "power-driven",
      "underway",
      "small"
    ]
  },
  {
    "id": "r23-hovercraft",
    "rule": 23,
    "cite": [
      "b",
      "a",
      "a(i)",
      "a(iii)",
      "a(iv)"
    ],
    "scope": "both",
    "cfr": "83.23",
    "cfrCite": [
      "b"
    ],
    "title": {
      "en": "Air-cushion vessel in non-displacement mode",
      "de": "Luftkissenfahrzeug im nichtverdrängenden Zustand"
    },
    "vessel": "hovercraft",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "yellow",
        "mount": "best-seen",
        "tier": 1,
        "rhythm": "flashing"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "The lights of a power-driven vessel plus one flashing yellow all-round light. The flash is the warning: this vessel can be much faster than her size suggests and she does not turn like a displacement hull.",
      "de": "Die Lichter eines Maschinenfahrzeugs plus ein gelbes Funkellicht rundum. Das Funkeln ist die Warnung: dieses Fahrzeug ist schneller, als seine Größe vermuten lässt, und es dreht nicht wie ein verdrängender Rumpf."
    },
    "tags": [
      "power-driven",
      "underway",
      "flashing"
    ]
  },
  {
    "id": "r23-wig",
    "rule": 23,
    "cite": [
      "c",
      "a",
      "a(i)",
      "a(iii)",
      "a(iv)"
    ],
    "scope": "both",
    "cfr": "83.23",
    "cfrCite": [
      "c"
    ],
    "title": {
      "en": "WIG craft taking off, landing or in flight",
      "de": "WIG-Fahrzeug beim Start, Landen und im Flug"
    },
    "vessel": "wig",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 1,
        "rhythm": "flashing"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "A high intensity flashing red all-round light on top of the normal lights. Only while taking off, landing or flying near the surface: at that moment the craft cannot give way to anyone.",
      "de": "Ein rotes Funkellicht hoher Leuchtstärke über den normalen Lichtern. Nur beim Start, beim Landen und im Flug dicht über der Oberfläche: in diesem Moment kann das Fahrzeug niemandem ausweichen."
    },
    "tags": [
      "power-driven",
      "underway",
      "flashing"
    ]
  },
  {
    "id": "r24-towing-le200",
    "rule": 24,
    "cite": [
      "a",
      "a(ii)",
      "a(iii)",
      "a(iv)"
    ],
    "scope": "both",
    "cfr": "83.24",
    "cfrCite": [
      "a",
      "a(i)",
      "a(ii)",
      "a(iii)",
      "a(iv)"
    ],
    "title": {
      "en": "Towing astern, tow up to 200 m",
      "de": "Schleppen, Schlepplänge bis 200 m"
    },
    "vessel": "tug",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern",
        "tier": 0
      },
      {
        "type": "towing",
        "colour": "yellow",
        "mount": "stern",
        "tier": 1
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "Two masthead lights in a vertical line instead of one, and a yellow towing light above the sternlight. The yellow light is the whole message: there is something behind this vessel, and you must not pass between them.",
      "de": "Zwei Topplichter senkrecht übereinander statt eines, und ein gelbes Schlepplicht über dem Hecklicht. Das gelbe Licht ist die ganze Botschaft: hinter diesem Fahrzeug hängt etwas, und dazwischen fährt niemand durch."
    },
    "tags": [
      "towing",
      "underway"
    ]
  },
  {
    "id": "r24-towing-gt200",
    "rule": 24,
    "cite": [
      "a",
      "a(ii)",
      "a(iii)",
      "a(iv)",
      "a(v)"
    ],
    "scope": "both",
    "cfr": "83.24",
    "cfrCite": [
      "a",
      "a(i)",
      "a(v)"
    ],
    "title": {
      "en": "Towing astern, tow over 200 m",
      "de": "Schleppen, Schlepplänge über 200 m"
    },
    "vessel": "tug",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 2
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern",
        "tier": 0
      },
      {
        "type": "towing",
        "colour": "yellow",
        "mount": "stern",
        "tier": 1
      }
    ],
    "dayShapes": [
      {
        "kind": "diamond",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "Three masthead lights in a vertical line: the tow is longer than 200 m, measured from the stern of the towing vessel to the after end of the tow. Count the white lights before you decide how far ahead you can cross.",
      "de": "Drei Topplichter senkrecht: der Schleppzug ist länger als 200 m, gemessen vom Heck des Schleppers bis zum Ende des Anhangs. Zähle die weißen Lichter, bevor du entscheidest, wie weit vor ihm du queren kannst."
    },
    "tags": [
      "towing",
      "underway",
      "long-tow"
    ]
  },
  {
    "id": "r24-composite-unit",
    "rule": 24,
    "cite": [
      "b",
      "23:a",
      "23:a(i)",
      "23:a(iii)",
      "23:a(iv)"
    ],
    "scope": "both",
    "cfr": "83.24",
    "cfrCite": [
      "b"
    ],
    "title": {
      "en": "Pushing in a rigid composite unit",
      "de": "Schieben im starren Verband"
    },
    "vessel": "tug",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "Rigidly connected means: one vessel. The unit shows the lights of a power-driven vessel of its combined length, nothing that hints at towing.",
      "de": "Starr verbunden heißt: ein Fahrzeug. Der Verband führt die Lichter eines Maschinenfahrzeugs seiner Gesamtlänge, nichts deutet auf Schleppen hin."
    },
    "tags": [
      "towing",
      "pushing",
      "underway"
    ]
  },
  {
    "id": "r24-pushing-alongside",
    "rule": 24,
    "cite": [
      "c",
      "c(i)",
      "c(ii)",
      "c(iii)"
    ],
    "scope": "international",
    "title": {
      "en": "Pushing ahead or towing alongside",
      "de": "Schieben oder längsseits schleppen"
    },
    "vessel": "tug",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern",
        "tier": 0
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "Two masthead lights again, but no yellow towing light: the load is beside or ahead of the vessel, not behind it. Under the US inland rules the same vessel shows two yellow towing lights instead of the sternlight.",
      "de": "Wieder zwei Topplichter, aber kein gelbes Schlepplicht: die Last hängt nicht achtern, sondern längsseits oder voraus. Nach den US-Binnenregeln führt dasselbe Fahrzeug statt des Hecklichts zwei gelbe Schlepplichter."
    },
    "tags": [
      "towing",
      "pushing",
      "underway"
    ]
  },
  {
    "id": "r24-towed-vessel",
    "rule": 24,
    "cite": [
      "e",
      "e(i)",
      "e(ii)"
    ],
    "scope": "both",
    "cfr": "83.24",
    "cfrCite": [
      "e",
      "e(i)",
      "e(ii)"
    ],
    "title": {
      "en": "Vessel being towed",
      "de": "Geschlepptes Fahrzeug"
    },
    "vessel": "barge",
    "lengthClass": "ge50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "Sidelights and a sternlight, no masthead light: the tow has no engine of its own. Seen from ahead it looks like a sailing vessel, and only the towing vessel ahead of it explains the picture.",
      "de": "Seitenlichter und Hecklicht, kein Topplicht: der Anhang hat keine eigene Maschine. Von vorn sieht er aus wie ein Segelfahrzeug, und erst der Schlepper davor erklärt das Bild."
    },
    "tags": [
      "towing",
      "underway"
    ]
  },
  {
    "id": "r24-inconspicuous-tow",
    "rule": 24,
    "cite": [
      "g",
      "g(iv)",
      "g(i)"
    ],
    "scope": "international",
    "title": {
      "en": "Inconspicuous, partly submerged tow",
      "de": "Unauffälliges, teilweise getauchtes Schleppobjekt"
    },
    "vessel": "barge",
    "lengthClass": "ge50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "bow",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "stern",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "diamond",
        "mount": "stern",
        "tier": 1
      }
    ],
    "explanation": {
      "en": "An all-round white light at each end, more lights when the object is wider than 25 m or longer than 100 m. Nothing here says which way it faces: you only learn the shape of the obstacle by counting the lights.",
      "de": "Je ein weißes Rundumlicht an beiden Enden, mehr Lichter bei über 25 m Breite oder 100 m Länge. Nichts daran sagt, wohin es zeigt: die Form des Hindernisses erschließt sich nur aus der Zahl der Lichter."
    },
    "tags": [
      "towing",
      "underway"
    ]
  },
  {
    "id": "r25-sailing-underway",
    "rule": 25,
    "cite": [
      "a",
      "a(i)",
      "a(ii)"
    ],
    "scope": "both",
    "cfr": "83.25",
    "cfrCite": [
      "a",
      "a(i)",
      "a(ii)"
    ],
    "title": {
      "en": "Sailing vessel underway",
      "de": "Segelfahrzeug in Fahrt"
    },
    "vessel": "sailing-yacht",
    "lengthClass": "m12to20",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "A sailing vessel shows sidelights and a sternlight, never a masthead light. That absence is the whole message: no white light above the sidelights means sail, and sail has right of way over a power-driven vessel under Rule 18.",
      "de": "Ein Segelfahrzeug zeigt Seitenlichter und Hecklicht, nie ein Topplicht. Genau das Fehlen ist die Botschaft: kein weißes Licht über den Seitenlichtern heißt Segel, und Segel hat nach Regel 18 Vorrang vor dem Maschinenfahrzeug."
    },
    "tags": [
      "sailing",
      "underway"
    ]
  },
  {
    "id": "r25-sailing-tricolour",
    "rule": 25,
    "cite": [
      "b",
      "a",
      "a(i)",
      "a(ii)"
    ],
    "scope": "both",
    "cfr": "83.25",
    "cfrCite": [
      "b"
    ],
    "title": {
      "en": "Sailing vessel under 20 m with tricolour lantern",
      "de": "Segelfahrzeug unter 20 m mit Dreifarbenlaterne"
    },
    "vessel": "sailing-yacht",
    "lengthClass": "m12to20",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "masthead-top"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "masthead-top"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "masthead-top"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "The same three sectors, but combined in one lantern at the top of the mast. High up it is seen from far away, and in a seaway it swings; close to other traffic the deck level lights are the better choice.",
      "de": "Dieselben drei Sektoren, aber in einer Laterne im Masttopp vereint. Weit oben ist sie von weitem zu sehen, im Seegang schwingt sie mit; in dichtem Verkehr sind die Lichter auf Decksniveau die bessere Wahl."
    },
    "tags": [
      "sailing",
      "underway"
    ]
  },
  {
    "id": "r25-sailing-red-over-green",
    "rule": 25,
    "cite": [
      "c",
      "a",
      "a(i)",
      "a(ii)"
    ],
    "scope": "both",
    "cfr": "83.25",
    "cfrCite": [
      "c"
    ],
    "title": {
      "en": "Sailing vessel with red over green at the masthead",
      "de": "Segelfahrzeug mit rot über grün im Masttopp"
    },
    "vessel": "sailing-yacht",
    "lengthClass": "m12to20",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "masthead-top",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "masthead-top",
        "tier": 1
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "Two all-round lights at the masthead, red above green, on top of the normal sailing lights. Optional, and never together with the tricolour lantern: red over green, sailing machine.",
      "de": "Zwei Rundumlichter im Masttopp, rot über grün, zusätzlich zu den normalen Segellichtern. Freiwillig, und nie zusammen mit der Dreifarbenlaterne: rot über grün, Segler unterwegs."
    },
    "tags": [
      "sailing",
      "underway"
    ]
  },
  {
    "id": "r25-sailing-lt7",
    "rule": 25,
    "cite": [
      "d(i)"
    ],
    "scope": "both",
    "cfr": "83.25",
    "cfrCite": [
      "d"
    ],
    "title": {
      "en": "Sailing vessel under 7 m",
      "de": "Segelfahrzeug unter 7 m"
    },
    "vessel": "sailing-dinghy",
    "lengthClass": "lt7",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "handlamp",
        "colour": "white",
        "mount": "deck",
        "tier": 0
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "If she cannot show the normal lights, an electric torch or a lantern with a white light must be ready at hand and shown in time to prevent collision. A light that is only shown when needed: that is why you must not rely on seeing small craft.",
      "de": "Kann sie die normalen Lichter nicht führen, muss eine elektrische Lampe oder Laterne mit weißem Licht griffbereit sein und rechtzeitig gezeigt werden. Ein Licht, das erst bei Bedarf erscheint: deshalb darf man sich nie darauf verlassen, kleine Fahrzeuge zu sehen."
    },
    "tags": [
      "sailing",
      "underway",
      "small"
    ]
  },
  {
    "id": "r25-rowing",
    "rule": 25,
    "cite": [
      "d(ii)"
    ],
    "scope": "both",
    "cfr": "83.25",
    "cfrCite": [
      "d(ii)"
    ],
    "title": {
      "en": "Vessel under oars",
      "de": "Ruderboot"
    },
    "vessel": "dinghy",
    "lengthClass": "lt7",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "handlamp",
        "colour": "white",
        "mount": "deck",
        "tier": 0
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "A vessel under oars may show the lights for sailing vessels; if she does not, a white torch has to be ready at hand. In the rules a rowing boat is not a sailing vessel, it simply borrows her lights.",
      "de": "Ein Ruderboot darf die Lichter für Segelfahrzeuge führen; tut es das nicht, muss eine weiße Lampe griffbereit sein. In den Regeln ist ein Ruderboot kein Segelfahrzeug, es leiht sich nur dessen Lichter."
    },
    "tags": [
      "rowing",
      "underway",
      "small"
    ]
  },
  {
    "id": "r25-motorsailing",
    "rule": 25,
    "cite": [
      "e",
      "23:a",
      "23:a(i)",
      "23:a(iii)",
      "23:a(iv)"
    ],
    "scope": "both",
    "cfr": "83.25",
    "cfrCite": [
      "e"
    ],
    "title": {
      "en": "Sailing vessel also propelled by machinery",
      "de": "Segelfahrzeug unter Maschine und Segel"
    },
    "vessel": "sailing-yacht",
    "lengthClass": "m12to20",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "cone-down",
        "mount": "bow",
        "tier": 1
      }
    ],
    "explanation": {
      "en": "Sails up and engine running makes her a power-driven vessel: masthead light at night, a cone with the apex downward by day. She loses the right of way of a sailing vessel the moment the engine is engaged.",
      "de": "Segel oben und Maschine an macht sie zum Maschinenfahrzeug: nachts das Topplicht, tags ein Kegel mit der Spitze nach unten. Den Vorrang des Seglers verliert sie in dem Moment, in dem die Maschine eingekuppelt ist."
    },
    "tags": [
      "sailing",
      "power-driven",
      "underway",
      "dayshape"
    ]
  },
  {
    "id": "r26-trawler-ge50",
    "rule": 26,
    "cite": [
      "b",
      "b(i)",
      "b(ii)",
      "b(iii)"
    ],
    "scope": "both",
    "cfr": "83.26",
    "cfrCite": [
      "b",
      "b(i)",
      "b(ii)",
      "b(iii)"
    ],
    "title": {
      "en": "Trawler of 50 m or more, making way",
      "de": "Trawler ab 50 m, mit Fahrt durchs Wasser"
    },
    "vessel": "trawler-large",
    "lengthClass": "ge50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-aft",
        "tier": 2
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "cones-apex",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "Green over white means trawling: she drags a net and cannot leave her course freely. From 50 m she also carries a masthead light abaft of and higher than the green light, which is how you tell her size at night.",
      "de": "Grün über weiß heißt Schleppnetzfischerei: sie zieht ein Netz und kann ihren Kurs nicht frei verlassen. Ab 50 m führt sie zusätzlich ein Topplicht achterlicher und höher als das grüne Licht, daran erkennst du nachts ihre Größe."
    },
    "tags": [
      "fishing",
      "trawling",
      "underway"
    ]
  },
  {
    "id": "r26-trawler-lt50",
    "rule": 26,
    "cite": [
      "b",
      "b(i)",
      "b(iii)"
    ],
    "scope": "both",
    "cfr": "83.26",
    "cfrCite": [
      "b",
      "b(i)",
      "b(iii)"
    ],
    "title": {
      "en": "Trawler under 50 m, making way",
      "de": "Trawler unter 50 m, mit Fahrt durchs Wasser"
    },
    "vessel": "trawler",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "cones-apex",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "Green over white without a masthead light: a trawler under 50 m may carry one but does not have to. No white light above the green pair is therefore no proof of anything except that she is fishing.",
      "de": "Grün über weiß ohne Topplicht: ein Trawler unter 50 m darf eines führen, muss aber nicht. Fehlendes weißes Licht über dem grünen Paar beweist also nur eines, nämlich dass gefischt wird."
    },
    "tags": [
      "fishing",
      "trawling",
      "underway"
    ]
  },
  {
    "id": "r26-fishing-other",
    "rule": 26,
    "cite": [
      "c",
      "c(i)",
      "c(iii)"
    ],
    "scope": "both",
    "cfr": "83.26",
    "cfrCite": [
      "c",
      "c(i)",
      "c(iii)"
    ],
    "title": {
      "en": "Fishing other than trawling",
      "de": "Fischerei außer Schleppnetzfischerei"
    },
    "vessel": "trawler",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "cones-apex",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "Red over white: fishing, but not trawling. Nets, lines or traps may lie in the water around her, so the danger is not only the vessel but everything she has out.",
      "de": "Rot über weiß: Fischerei, aber kein Schleppnetz. Netze, Leinen oder Reusen können rund um sie im Wasser liegen, gefährlich ist also nicht nur das Fahrzeug, sondern alles, was es ausgebracht hat."
    },
    "tags": [
      "fishing",
      "underway"
    ]
  },
  {
    "id": "r26-fishing-gear-150",
    "rule": 26,
    "cite": [
      "c",
      "c(i)",
      "c(ii)"
    ],
    "scope": "both",
    "cfr": "83.26",
    "cfrCite": [
      "c",
      "c(i)",
      "c(ii)"
    ],
    "title": {
      "en": "Fishing with gear extending more than 150 m",
      "de": "Fischerei mit Fanggeschirr über 150 m"
    },
    "vessel": "trawler",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "yardarm-stbd",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "cones-apex",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "kind": "cone-up",
        "mount": "yardarm-stbd",
        "tier": 1
      }
    ],
    "explanation": {
      "en": "A third all-round white light points to the gear: it stands in the direction in which the nets or lines extend more than 150 m from the vessel. Give way on that side by a wide margin, the hazard is under water.",
      "de": "Ein drittes weißes Rundumlicht zeigt zum Geschirr: es steht in der Richtung, in der Netze oder Leinen mehr als 150 m vom Fahrzeug weg liegen. Auf dieser Seite weit abhalten, die Gefahr liegt unter Wasser."
    },
    "tags": [
      "fishing",
      "gear"
    ]
  },
  {
    "id": "r26-not-fishing",
    "rule": 26,
    "cite": [
      "e",
      "23:a",
      "23:a(i)",
      "23:a(iii)",
      "23:a(iv)"
    ],
    "scope": "both",
    "cfr": "83.26",
    "cfrCite": [
      "e"
    ],
    "title": {
      "en": "Fishing vessel not engaged in fishing",
      "de": "Fischereifahrzeug ohne Fangtätigkeit"
    },
    "vessel": "trawler",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "On passage she is an ordinary power-driven vessel and must not show the fishing lights. The privilege of Rule 18 belongs to the activity, not to the vessel type.",
      "de": "Auf dem Weg zum Fanggebiet ist sie ein gewöhnliches Maschinenfahrzeug und darf die Fischereilichter nicht zeigen. Der Vorrang aus Regel 18 gehört der Tätigkeit, nicht der Fahrzeugart."
    },
    "tags": [
      "fishing",
      "power-driven",
      "underway"
    ]
  },
  {
    "id": "r27-nuc-stopped",
    "rule": 27,
    "cite": [
      "a",
      "a(i)",
      "a(ii)"
    ],
    "scope": "both",
    "cfr": "83.27",
    "cfrCite": [
      "a",
      "a(i)",
      "a(ii)"
    ],
    "title": {
      "en": "Not under command, no way on",
      "de": "Manövrierunfähig, ohne Fahrt durchs Wasser"
    },
    "vessel": "coaster",
    "lengthClass": "ge50",
    "underway": true,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 1
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 1
      }
    ],
    "explanation": {
      "en": "Two red all-round lights in a vertical line: through some exceptional circumstance she cannot manoeuvre and cannot keep out of the way. No sidelights and no sternlight, because she is not making way through the water.",
      "de": "Zwei rote Rundumlichter senkrecht: durch einen außergewöhnlichen Umstand kann sie nicht manövrieren und niemandem ausweichen. Keine Seitenlichter und kein Hecklicht, denn sie hat keine Fahrt durchs Wasser."
    },
    "tags": [
      "not-under-command",
      "dayshape"
    ]
  },
  {
    "id": "r27-nuc-making-way",
    "rule": 27,
    "cite": [
      "a",
      "a(i)",
      "a(iii)",
      "a(ii)"
    ],
    "scope": "both",
    "cfr": "83.27",
    "cfrCite": [
      "a",
      "a(i)",
      "a(iii)"
    ],
    "title": {
      "en": "Not under command, making way",
      "de": "Manövrierunfähig, mit Fahrt durchs Wasser"
    },
    "vessel": "coaster",
    "lengthClass": "ge50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 1
      }
    ],
    "explanation": {
      "en": "The same two red lights, now with sidelights and sternlight: she still moves through the water, she just cannot steer. The missing masthead light is the difference from a power-driven vessel underway.",
      "de": "Dieselben zwei roten Lichter, jetzt mit Seiten- und Hecklicht: sie bewegt sich noch durchs Wasser, kann aber nicht steuern. Das fehlende Topplicht ist der Unterschied zum Maschinenfahrzeug in Fahrt."
    },
    "tags": [
      "not-under-command",
      "underway"
    ]
  },
  {
    "id": "r27-ram",
    "rule": 27,
    "cite": [
      "b",
      "b(i)",
      "b(ii)",
      "b(iii)"
    ],
    "scope": "both",
    "cfr": "83.27",
    "cfrCite": [
      "b",
      "b(i)",
      "b(ii)",
      "b(iii)"
    ],
    "title": {
      "en": "Restricted in ability to manoeuvre",
      "de": "Manövrierbehindert"
    },
    "vessel": "workboat",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 2
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 2
      },
      {
        "kind": "diamond",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "Red over white over red: the nature of her work keeps her from keeping out of the way. Unlike a vessel not under command she can still steer, and while making way she also shows masthead light, sidelights and sternlight.",
      "de": "Rot über weiß über rot: die Art ihrer Arbeit hindert sie daran, auszuweichen. Anders als ein manövrierunfähiges Fahrzeug kann sie noch steuern, und mit Fahrt durchs Wasser führt sie zusätzlich Topp-, Seiten- und Hecklicht."
    },
    "tags": [
      "restricted",
      "underway",
      "dayshape"
    ]
  },
  {
    "id": "r27-towing-ram",
    "rule": 27,
    "cite": [
      "c",
      "b(i)",
      "b(ii)",
      "24:a",
      "24:a(ii)",
      "24:a(iii)",
      "24:a(iv)"
    ],
    "scope": "both",
    "cfr": "83.27",
    "cfrCite": [
      "c"
    ],
    "title": {
      "en": "Towing operation that severely restricts the tow",
      "de": "Schleppverband, der den Kurs nicht ändern kann"
    },
    "vessel": "tug",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 2
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 1
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern",
        "tier": 0
      },
      {
        "type": "towing",
        "colour": "yellow",
        "mount": "stern",
        "tier": 1
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 2
      },
      {
        "kind": "diamond",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "The towing lights of Rule 24 plus the red-white-red of a vessel restricted in her ability to manoeuvre. Together they say: there is a tow behind me and I cannot get out of your way.",
      "de": "Die Schlepplichter aus Regel 24 plus rot-weiß-rot des manövrierbehinderten Fahrzeugs. Zusammen heißt das: hinter mir hängt ein Anhang, und ausweichen kann ich nicht."
    },
    "tags": [
      "towing",
      "restricted",
      "underway"
    ]
  },
  {
    "id": "r27-dredging",
    "rule": 27,
    "cite": [
      "b(i)",
      "b(ii)",
      "d",
      "d(i)",
      "d(ii)"
    ],
    "scope": "both",
    "cfr": "83.27",
    "cfrCite": [
      "d",
      "d(i)",
      "d(ii)"
    ],
    "title": {
      "en": "Dredging or underwater operations with an obstruction",
      "de": "Baggerarbeiten mit Behinderung"
    },
    "vessel": "workboat",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 2
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "yardarm-port",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "yardarm-port",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "yardarm-stbd",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "yardarm-stbd",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 2
      },
      {
        "kind": "diamond",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 0
      },
      {
        "kind": "ball",
        "mount": "yardarm-port",
        "tier": 1
      },
      {
        "kind": "ball",
        "mount": "yardarm-port",
        "tier": 0
      },
      {
        "kind": "diamond",
        "mount": "yardarm-stbd",
        "tier": 1
      },
      {
        "kind": "diamond",
        "mount": "yardarm-stbd",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "Two red lights mark the side where the obstruction lies, two green lights the side on which you may pass. Read the pair first, then the course: the vessel herself may be lying across the channel.",
      "de": "Zwei rote Lichter stehen auf der Seite der Behinderung, zwei grüne auf der Seite, an der man vorbeifahren darf. Zuerst das Paar lesen, dann den Kurs: das Fahrzeug selbst kann quer im Fahrwasser liegen."
    },
    "tags": [
      "restricted",
      "dredging",
      "dayshape"
    ]
  },
  {
    "id": "r27-diving",
    "rule": 27,
    "cite": [
      "e",
      "e(i)",
      "e(ii)"
    ],
    "scope": "both",
    "cfr": "83.27",
    "cfrCite": [
      "e",
      "e(i)",
      "e(ii)"
    ],
    "title": {
      "en": "Small vessel engaged in diving operations",
      "de": "Taucherarbeiten, kleines Fahrzeug"
    },
    "vessel": "pilot-vessel",
    "lengthClass": "m12to20",
    "underway": true,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 2
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "flag-a",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "Too small for the full set of lights and shapes, she shows red-white-red and a rigid replica of flag A, at least one metre high. Divers are in the water: pass slowly and wide.",
      "de": "Zu klein für den vollen Satz an Lichtern und Signalkörpern zeigt sie rot-weiß-rot und eine starre Nachbildung der Flagge A, mindestens einen Meter hoch. Taucher sind im Wasser: langsam und weit vorbei."
    },
    "tags": [
      "restricted",
      "diving",
      "dayshape"
    ]
  },
  {
    "id": "r27-mine-clearance",
    "rule": 27,
    "cite": [
      "f",
      "23:a",
      "23:a(i)",
      "23:a(iii)",
      "23:a(iv)"
    ],
    "scope": "both",
    "cfr": "83.27",
    "cfrCite": [
      "f"
    ],
    "title": {
      "en": "Mine clearance operations",
      "de": "Minenräumarbeiten"
    },
    "vessel": "workboat",
    "lengthClass": "m20to50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "masthead-top",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "yardarm-port",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "green",
        "mount": "yardarm-stbd",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "masthead-top",
        "tier": 0
      },
      {
        "kind": "ball",
        "mount": "yardarm-port",
        "tier": 0
      },
      {
        "kind": "ball",
        "mount": "yardarm-stbd",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "Three green all-round lights in a triangle: one near the foremast head, one at each end of the fore yard, on top of the normal lights. They mean it is dangerous to approach within 1000 metres.",
      "de": "Drei grüne Rundumlichter im Dreieck: eines am Vormasttopp, je eines an den Rahnocken, zusätzlich zu den normalen Lichtern. Sie heißen: näher als 1000 Meter heranzukommen ist gefährlich."
    },
    "tags": [
      "restricted",
      "mine-clearance",
      "dayshape"
    ]
  },
  {
    "id": "r28-constrained-draught",
    "rule": 28,
    "cite": [
      "intro",
      "23:a",
      "23:a(i)",
      "23:a(ii)",
      "23:a(iii)",
      "23:a(iv)"
    ],
    "scope": "international",
    "title": {
      "en": "Vessel constrained by her draught",
      "de": "Tiefgangbehindertes Fahrzeug"
    },
    "vessel": "cargo",
    "lengthClass": "ge50",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-aft",
        "tier": 1
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 2
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "cylinder",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "Three red all-round lights in a vertical line on top of the lights of a power-driven vessel, by day a cylinder. She can only stay in the deep water she needs, so everyone else keeps clear. The US inland rules do not know this signal.",
      "de": "Drei rote Rundumlichter senkrecht über den Lichtern eines Maschinenfahrzeugs, am Tag ein Zylinder. Sie kann nur im tiefen Wasser bleiben, das sie braucht, also halten sich alle anderen frei. Die US-Binnenregeln kennen dieses Signal nicht."
    },
    "tags": [
      "constrained-draught",
      "underway",
      "dayshape"
    ]
  },
  {
    "id": "r29-pilot-underway",
    "rule": 29,
    "cite": [
      "a",
      "a(i)",
      "a(ii)"
    ],
    "scope": "both",
    "cfr": "83.29",
    "cfrCite": [
      "a",
      "a(i)",
      "a(ii)"
    ],
    "title": {
      "en": "Pilot vessel on duty, underway",
      "de": "Lotsenfahrzeug im Dienst, in Fahrt"
    },
    "vessel": "pilot-vessel",
    "lengthClass": "m12to20",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "masthead-top",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "masthead-top",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "White over red at the masthead, plus sidelights and sternlight: the pilot is at work. The mnemonic runs white over red, pilot ahead, and it is the only combination in that order.",
      "de": "Weiß über rot im Masttopp, dazu Seiten- und Hecklicht: der Lotse ist im Dienst. Die Eselsbrücke lautet weiß über rot, Lotsenboot, und diese Reihenfolge gibt es sonst nirgends."
    },
    "tags": [
      "pilot",
      "underway"
    ]
  },
  {
    "id": "r29-pilot-anchored",
    "rule": 29,
    "cite": [
      "a",
      "a(i)",
      "a(iii)",
      "30:b",
      "30:a(i)"
    ],
    "scope": "both",
    "cfr": "83.29",
    "cfrCite": [
      "a",
      "a(i)",
      "a(iii)"
    ],
    "title": {
      "en": "Pilot vessel on duty, at anchor",
      "de": "Lotsenfahrzeug im Dienst, ankernd"
    },
    "vessel": "pilot-vessel",
    "lengthClass": "m12to20",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "masthead-top",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "masthead-top",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "bow",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "bow",
        "tier": 1
      }
    ],
    "explanation": {
      "en": "White over red stays, sidelights and sternlight go, the anchor light comes. So a pilot vessel waiting on station shows three white-and-red lights and nothing that suggests movement.",
      "de": "Weiß über rot bleibt, Seiten- und Hecklicht gehen, das Ankerlicht kommt. Ein wartendes Lotsenfahrzeug zeigt also drei Lichter in weiß und rot und nichts, was auf Fahrt hindeutet."
    },
    "tags": [
      "pilot",
      "anchored"
    ]
  },
  {
    "id": "r30-anchored-lt50",
    "rule": 30,
    "cite": [
      "a",
      "a(i)",
      "b"
    ],
    "scope": "both",
    "cfr": "83.30",
    "cfrCite": [
      "a",
      "a(i)",
      "b"
    ],
    "title": {
      "en": "Vessel at anchor, less than 50 m",
      "de": "Ankerlieger unter 50 m"
    },
    "vessel": "coaster",
    "lengthClass": "m20to50",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "bow",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "One all-round white light and nothing else: a vessel at anchor shows no sidelights and no sternlight, because it is not underway. By day the same message is one black ball forward.",
      "de": "Ein weißes Rundumlicht und sonst nichts: ein Ankerlieger zeigt keine Seitenlichter und kein Hecklicht, weil er nicht in Fahrt ist. Am Tag sagt dasselbe ein schwarzer Ball vorn."
    },
    "tags": [
      "anchored",
      "allround"
    ]
  },
  {
    "id": "r30-anchored-ge50",
    "rule": 30,
    "cite": [
      "a",
      "a(i)",
      "a(ii)",
      "c"
    ],
    "scope": "both",
    "cfr": "83.30",
    "cfrCite": [
      "a",
      "a(i)",
      "a(ii)",
      "c"
    ],
    "title": {
      "en": "Vessel at anchor, 50 m or more",
      "de": "Ankerlieger ab 50 m"
    },
    "vessel": "cargo",
    "lengthClass": "ge50",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "bow",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "stern",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "bow",
        "tier": 2
      }
    ],
    "explanation": {
      "en": "Two anchor lights, the forward one higher: the line between them shows the length and which way she lies to the tide. From 100 m she must also light her decks, which is why a big anchored ship looks like a lit factory.",
      "de": "Zwei Ankerlichter, das vordere höher: die Linie dazwischen zeigt Länge und Lage zum Strom. Ab 100 m muss sie zusätzlich ihre Decks beleuchten, deshalb sieht ein großer Ankerlieger aus wie eine erleuchtete Fabrik."
    },
    "tags": [
      "anchored",
      "allround"
    ]
  },
  {
    "id": "r30-aground",
    "rule": 30,
    "cite": [
      "a",
      "a(i)",
      "a(ii)",
      "d",
      "d(i)",
      "d(ii)"
    ],
    "scope": "both",
    "cfr": "83.30",
    "cfrCite": [
      "d",
      "d(i)",
      "d(ii)"
    ],
    "title": {
      "en": "Vessel aground",
      "de": "Fahrzeug auf Grund"
    },
    "vessel": "coaster",
    "lengthClass": "ge50",
    "underway": false,
    "makingWay": false,
    "lights": [
      {
        "type": "allround",
        "colour": "white",
        "mount": "bow",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "white",
        "mount": "stern",
        "tier": 0
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "type": "allround",
        "colour": "red",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "dayShapes": [
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 2
      },
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 1
      },
      {
        "kind": "ball",
        "mount": "best-seen",
        "tier": 0
      }
    ],
    "explanation": {
      "en": "The anchor lights plus two red all-round lights, by day three balls. Two reds also mean not under command, so the anchor lights below them are what tells you she is stuck, not drifting.",
      "de": "Die Ankerlichter plus zwei rote Rundumlichter, am Tag drei Bälle. Zwei rote Lichter heißen auch manövrierunfähig, erst die Ankerlichter darunter sagen: sie sitzt fest und treibt nicht."
    },
    "tags": [
      "aground",
      "dayshape"
    ]
  },
  {
    "id": "r31-seaplane",
    "rule": 31,
    "cite": [
      "intro",
      "23:a",
      "23:a(i)",
      "23:a(iii)",
      "23:a(iv)"
    ],
    "scope": "both",
    "cfr": "83.31",
    "cfrCite": [
      "intro"
    ],
    "title": {
      "en": "Seaplane on the water",
      "de": "Wasserflugzeug auf dem Wasser"
    },
    "vessel": "seaplane",
    "lengthClass": "m12to20",
    "underway": true,
    "makingWay": true,
    "lights": [
      {
        "type": "masthead",
        "colour": "white",
        "mount": "mast-fwd",
        "tier": 0
      },
      {
        "type": "sidelight-port",
        "colour": "red",
        "mount": "bow"
      },
      {
        "type": "sidelight-stbd",
        "colour": "green",
        "mount": "bow"
      },
      {
        "type": "sternlight",
        "colour": "white",
        "mount": "stern"
      }
    ],
    "dayShapes": [],
    "explanation": {
      "en": "A seaplane on the water is a vessel and carries the lights of a power-driven vessel, as closely as its shape allows. The sidelights sit far apart on the wings, which makes it look much wider than it is.",
      "de": "Ein Wasserflugzeug auf dem Wasser ist ein Fahrzeug und führt die Lichter eines Maschinenfahrzeugs, so genau es seine Form zulässt. Die Seitenlichter sitzen weit außen an den Tragflächen, dadurch wirkt es viel breiter, als es ist."
    },
    "tags": [
      "seaplane",
      "underway"
    ]
  }
]
